import { render, staticRenderFns } from "./KnFormNoteOfMandatory.vue?vue&type=template&id=5d41922c"
import script from "./KnFormNoteOfMandatory.vue?vue&type=script&lang=js"
export * from "./KnFormNoteOfMandatory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports